<template>
  <div class="live">
    <div class="content">
      <swiper :options="swiperOption" v-if="scrollImg.length">
        <swiper-slide class="swiper-img" v-for="(item,index) in scrollImg" :key="index">
          <LiveCard
            :show-footer="false"
            :course-id="item.courseId"
            :channel-id="item.channelId"
            :notice-id="item.id"
            :img="item.image"
            :status="item.noticestatus"
            :type="item.courseType"
            :padding="false"
            :is-free="item.free"
          >
            <div slot="card-body">
              <LiveSinal
                v-if="item.noticestatus != 2"
                :isLive="item.noticestatus == 1"
                :heat="item.heatDegree"
                :live-time="item.startTime && item.startTime.slice(11, 16)"
              ></LiveSinal>
            </div>
          </LiveCard>
        </swiper-slide>
        <div class="swiper-pagination" slot="pagination"></div>
      </swiper>
      <div class="info">
        <LiveCard
          style="margin-bottom:8px"
          v-for="(live, key) in liveList"
          :name="live.videoName"
          :key="key"
          :live-time="live.startTime"
          :course-id="live.courseId"
          :channel-id="live.channelId"
          :view-num="live.viewerCount"
          :img="live.image"
          :status="live.noticestatus"
          :type="live.courseType"
          :show-head="key==0"
          signal-top="0.59rem"
          :is-free="live.free"
        >
          <div v-if="key==0" class="card-head" slot="type" :style="{borderColor: '#fd042d'}">正在直播</div>
          <div slot="card-body">
            <LiveSinal :isLive="true" :heat="live.heatDegree==null?0:live.heatDegree"></LiveSinal>
          </div>
        </LiveCard>
        <LiveCard
          style="margin-bottom:8px"
          v-for="(preview, key) in previewList"
          :name="preview.videoName"
          :key="preview.id"
          :notice-id="preview.id"
          :live-time="preview.startTime"
          :course-id="preview.courseId"
          :channel-id="preview.channelId"
          :status="preview.noticestatus"
          :type="preview.courseType"
          :img="preview.image"
          :show-head="key==0"
          :is-free="preview.free"
          :show-view-num="false"
        >
          <div v-if="key==0" class="card-head" slot="type">即将播出</div>
        </LiveCard>
        <!-- <LiveCard style="margin-bottom:8px">
                    <div class="card-head" slot="type">正在直播</div>
                    <div slot="card-body">
                        <LiveSinal></LiveSinal>
                    </div>
                </LiveCard>
        <LiveCard style="margin-bottom:8px"></LiveCard>-->
        <LiveCard
          style="margin-bottom:8px"
          v-for="(review, key) in reviewList"
          :course-id="review.courseId"
          :channel-id="review.channelId"
          :key="review.id"
          :live-time="review.liveStartTime"
          :name="review.videoTitle"
          :view-num="review.viewerCount"
          :img="review.recordImgUrl"
          :status="review.videoStatus"
          :type="review.courseType"
          :is-free="review.free"
          :show-head="key==0"
        >
          <template v-if="key==0">
            <div class="card-head" slot="type" :style="{borderColor: '#1b6afb'}">直播回放</div>
            <div slot="calender" class="calender-wrapper">
              <img class="calender" src="~@/assets/calender.png" />
              <input
                type="date"
                name
                id
                v-model="date"
                @blur="dateBlur"
                @change="dateChange"
                ref="date-picker"
              />
            </div>
          </template>
        </LiveCard>
      </div>
      <!-- <div class="load-more" v-if="showLoadMore&&reviewList.length>0" @click="loadMoreReview">点击加载更多</div> -->
    </div>

    <Header></Header>
  </div>
</template>

<script>
import jsonp from "jsonp";
import Header from "../../components/Header";
import LiveCard from "@/components/LiveCard";
import LiveSinal from "@/components/LiveSignal";
import { getLiveList, getReviewList } from "@/utils/http";
import { mapState, mapMutations } from "vuex";
// import emH5Share from "../emH5Share.js";
const CONSTANST = {
  LIVE: 1, //直播
  PREVIEW: 0, //直播预告
  CURRENT_DATE: 0, //当天预告
  CURRENT_WEEK: 1, //当周预告
  ALL: 2 //所有
};
export default {
  components: {
    Header,
    LiveCard,
    LiveSinal
  },
  computed: {
    ...mapState(["reviewDate"])
  },
  data() {
    return {
      swiperOption: {
        direction: "horizontal",
        initialSlide: 0,
        // loop: true,
        autoplay: 2000,
        slidesPerView: "auto",
        centeredSlides: true,
        spaceBetween: 1,
        pagination: ".swiper-pagination",
        onClick: swiper => {}
      },
      date: "",
      scrollImg: [],
      liveList: [],
      previewList: [],
      reviewList: [],
      reviewPage: 1, //录播视频分页页码
      reviewPageSize: 3, //录播视频分页显示数量
      showLoadMore: true,
      miniToken: ""
    };
  },
  mounted() {
    window.AG.emH5ShareNeed(0);
    this.date = this.reviewDate;
    //获取直播列表
    this.getLiveOrPreviewList(CONSTANST.LIVE, CONSTANST.CURRENT_DATE).then(
      json => {
        const res = json.data;
        if (+res.code == 0) {
          res.data.forEach(item => {
            item.notices.forEach(course => {
              if (course.noticestatus == 0) {
                this.previewList.push(course);
              } else if (course.noticestatus == 1) {
                this.liveList.push(course);
              }
            });
          });
        }
      }
    );
    //获取轮播图
    getLiveList({
      getPlayback: true,
      noticeStatus: 3,
      noticeType: 0,
      pageNum: 1,
      pageSize: 4
    }).then(res => {
      this.scrollImg = res.data.data[0].notices;
    });
    if (this.date) {
      this.renderReviewList();
    } else {
      this.renderReviewList(0, 4);
    }
    // this.initShare();
    this.miniToken =
      this.$route.query.miniToken || localStorage.getItem("miniToken") || "";
    localStorage.setItem("miniToken", this.miniToken);
  },
  methods: {
    ...mapMutations(["setReviewDate"]),
    initShare() {
      // emH5.ShareData = {
      //   title: "金牌课程",
      //   desc: "为您精选投资课程",
      //   link: window.location.href,
      //   imgUrl:
      //     "https://emfed.eastmoney.com/public/resource/img/wechatlogo.png",
      //   fail: function(res) {
      //     alert(JSON.stringify(res));
      //   }
      // };
      // emH5.Share();
    },
    //兼容android与ios, android input选择日期后会立即触发change事件
    dateChange() {
      if (!navigator.userAgent.match(/iphone/i)) {
        this.renderReviewList();
      }
    },
    //兼容android与ios, ios input选择日期后会立即触发blur事件
    dateBlur() {
      if (navigator.userAgent.match(/iphone/i)) {
        this.renderReviewList();
      }
    },
    getLiveOrPreviewList(noticeStatus, noticeType, getPlayback = false) {
      return new Promise(resolve => {
        getLiveList({
          getPlayback,
          noticeStatus,
          noticeType
        }).then(res => {
          resolve(res);
        });
      });
    },
    renderReviewList(pageNum, pageSize) {
      const option = {
        liveDate: this.date
      };
      if (!this.date) {
      }
      getReviewList({
        liveDate: this.date,
        pageNum,
        pageSize
      }).then(json => {
        const res = json.data;
        if (+res.code == 0 && res.data.length) {
          this.setReviewDate(this.date);
          this.reviewList = res.data;
        } else {
          this.$toast("所选日期无直播");
          this.setReviewDate("");
        }
      });
    },
    jumpCourse(v) {
      this.$router.push({
        path: "/courseInfo",
        query: { courseId: v }
      });
    },
    loadMoreReview() {
      this.reviewPage++;
      this.renderReviewList(true); //加载更多
    }
  }
};
</script>

<style scoped>
.live {
  background: #f5f5f5;
}
.content {
  padding-bottom: 50px;
}
.swiper-container {
  width: 100%;
  height: 3rem;
  padding-top: 0.2rem;
  font-size: 16px;
  background: #fff;
}
.swiper-slide:not(.swiper-slide-active) {
  transform: scale(0.9);
}
.swiper-img {
  height: 2.8rem;
  width: 6.56rem;
  border-radius: 8px;
  overflow: hidden;
}
.swiper-img img {
  width: 100%;
}
.card-head {
  margin: 8px 0;
  padding-left: 8px;
  border-left: 4px solid #ead204;
  line-height: 1;
}
.calender-wrapper {
  position: relative;
}
.calender {
  display: inline-block;
  position: absolute;
  right: 4px;
  top: 50%;
  width: 0.3rem;
  height: 0.3rem;
  transform: translateY(-50%);
  font-size: 16px;
}
input[type="date"] {
  opacity: 0;
  width: 0.3rem;
  height: 0.3rem;
  position: absolute;
  right: 4px;
  top: 50%;
  transform: translateY(-50%);
}
.load-more {
  margin-top: -8px;
  font-size: 14px;
  line-height: 50px;
  background: #fff;
  border-top: 1px solid #f5f5f5;
}
/deep/.swiper-pagination {
  /* top: 78px; */
  bottom: 8px;
}
/deep/ .swiper-pagination .swiper-pagination-bullet {
  display: inline-block;
  width: 0.35rem !important;
  height: 0.04rem;
  border-radius: 0;
}
/deep/ .swiper-pagination .swiper-pagination-bullet-active {
  background-color: #fff !important;
}
/deep/ .swiper-img .card-body {
  margin: 0 !important;
  padding-top: 0 !important;
  background-position: 0 0 !important;
}
</style>